export default function SectionKicker({ index, label }) {
  return (
    <p className="mb-4 font-heading text-xs font-bold uppercase tracking-widest text-omnyx-teal">
      <span className="text-site-ink/30">{index}</span> {label}
    </p>
  );
}
